import { useEffect } from 'react';

// Captures a partner referral code from the URL (?parceiro=CODE or ?ref=CODE)
// and persists it in localStorage so the booking flow can attach it to the
// reservation. Runs once on app mount.
export default function PartnerReferralCapture() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('parceiro') || params.get('ref');
      if (code) {
        localStorage.setItem('partnerReferralCode', code.trim());
      }
    } catch (_) { /* localStorage unavailable */ }
  }, []);
  return null;
}